import { render } from "./CounterSeatDetails.vue?vue&type=template&id=312c0c1b&scoped=true"
import script from "./CounterSeatDetails.vue?vue&type=script&lang=js"
export * from "./CounterSeatDetails.vue?vue&type=script&lang=js"

import "./CounterSeatDetails.vue?vue&type=style&index=0&id=312c0c1b&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312c0c1b"]])

export default __exports__